import React from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

interface LoadingSpinnerProps {
  size?: 'xs' | 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeMap: Record<NonNullable<LoadingSpinnerProps['size']>, string> = {
  xs: 'size-3',
  sm: 'size-4',
  md: 'size-6',
  lg: 'size-8',
};

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ size = 'md', className = '' }): React.JSX.Element => {
  return <Loader2 className={cn('animate-spin text-primary', sizeMap[size], className)} role='status' aria-label='Wird geladen' />;
};
